import pt from './pt';
import en from './en';

export default { pt, en };
